import * as React from 'react';
import { capitaliseFirstLetter } from '../../utils';
import { Box } from '../Box';
import * as flexboxStyles from '../common/flexbox.module.css';
import * as styles from './Row.module.css';

export const Row = React.forwardRef(function Row(
  {
    align = 'stretch',
    children,
    className = '',
    element = 'div',
    gap = 'none',
    height = 'auto',
    justify = 'start',
    padding = 'none',
    reverse = false,
    width = 'auto',
    ...rest
  },
  ref,
) {
  const gapClass = `gap${capitaliseFirstLetter(gap)}`;
  const alignClass = `align${capitaliseFirstLetter(align)}`;
  const justifyClass = `justify${capitaliseFirstLetter(justify)}`;

  const combinedClasses = [
    styles.row,
    flexboxStyles[gapClass],
    flexboxStyles[alignClass],
    flexboxStyles[justifyClass],
    reverse && styles.reverse,
    className
  ]
  .filter(Boolean)
  .join(' ');

  return (
    <Box
      className={combinedClasses}
      display="flex"
      element={element}
      height={height}
      padding={padding}
      ref={ref}
      width={width}
      {...rest}
    >
      {children}
    </Box>
  );
});
